export default __webpack_public_path__ + "static/media/uclm.94ea727c.jpg";